// import angular from "angular";
// import SyncData from "servicestack/sync-data/sync-data";

// const dependencies = ['emun.auth', 'webutils', 'webforms', 'webmodals', 'ui.router'];

// export default angular.module('sync-data', dependencies)
//   .component('syncData', SyncData)
//   .name;
